import _ from 'lodash';
import { useEffect, useState } from 'react';
import { useRecoilValue } from 'recoil';
import { cloneWithoutTypename } from '../../common/utils';
import { filterPresetsDescriptors } from '../../filterPreset/store/filterPreset.state';
import { warehouseCanUpdate } from '../../store/warehouse.state';
import { simulationCurrent } from '../store/simulation.state';
import useUpdateSimulation from './useUpdateSimulation';

function useSimulationPresentationWatcher() {
  const simulation = useRecoilValue(simulationCurrent);
  const canUpdate = useRecoilValue(warehouseCanUpdate);
  const updateSim = useUpdateSimulation();
  const [firstLoad, setFirstLoad] = useState<boolean>(true);
  const filterPresets = useRecoilValue(filterPresetsDescriptors);

  useEffect(() => {
    if (_.isNil(simulation) || !canUpdate) return;
    if (firstLoad) {
      setFirstLoad(false);
    } else {
      updateSim(
        {
          presentationSettings: {
            filterPresetDescriptors: cloneWithoutTypename(filterPresets),
          },
        },
        simulation.id,
      );
    }
  }, [filterPresets]);
}

export default useSimulationPresentationWatcher;
